import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import AnalysisResultsLive from './pages/analysis-results-live';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import BlogListing from './pages/blog';
import BlogPostSkills from './pages/blog/posts/top-skills-employers-looking-for-2025';
import BlogPostJobTruth from './pages/blog/posts/hard-truth-about-finding-a-Job-in-India';


import UserLogin from './pages/user-login';
import UserRegister from './pages/user-register';
import ResumeUploadAnalysis from './pages/resume-upload-analysis';
import UserDashboard from './pages/user-dashboard';
import AnalysisResultsDashboard from './pages/analysis-results-dashboard';
import ResumeRewriterTool from './pages/resume-rewriter-tool';
import SkillGapLearningPath from './pages/skill-gap-learning-path';
import AIChatPage from './pages/ai-chat';
import NotFound from './pages/NotFound';
import UpgradePage from './pages/upgrade';
import PaymentSuccess from './pages/payment-success';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<UserLogin />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/register" element={<UserRegister />} />
          <Route path="/signup" element={<UserRegister />} />
          <Route path="/user-register" element={<UserRegister />} />

          {/* Public Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />

          {/* Blog Routes */}
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/top-skills-employers-looking-for-2026" element={<BlogPostSkills />} />
          <Route path="/blog/hard-truth-about-finding-a-Job-in-India" element={<BlogPostJobTruth />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          } />
          <Route path="/user-dashboard" element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          } />
          <Route path="/upload-analysis" element={
            <ProtectedRoute>
              <ResumeUploadAnalysis />
            </ProtectedRoute>
          } />
          <Route path="/resume-upload-analysis" element={
            <ProtectedRoute>
              <ResumeUploadAnalysis />
            </ProtectedRoute>
          } />
          <Route path="/analysis-results/:id" element={
            <ProtectedRoute>
              <AnalysisResultsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/analysis-results-dashboard/:id" element={
            <ProtectedRoute>
              <AnalysisResultsDashboard />
            </ProtectedRoute>
          } />

          <Route
            path="/analysis-results-live"
            element={
              <ProtectedRoute>
                <AnalysisResultsLive />
              </ProtectedRoute>
            }
          />

          <Route path="/resume-rewriter" element={
            <ProtectedRoute>
              <ResumeRewriterTool />
            </ProtectedRoute>
          } />
          <Route path="/resume-rewriter-tool" element={
            <ProtectedRoute>
              <ResumeRewriterTool />
            </ProtectedRoute>
          } />
          <Route path="/skill-gaps" element={
            <ProtectedRoute>
              <SkillGapLearningPath />
            </ProtectedRoute>
          } />
          <Route path="/skill-gap-learning-path" element={
            <ProtectedRoute>
              <SkillGapLearningPath />
            </ProtectedRoute>
          } />
          <Route path="/ai-chat" element={
            <ProtectedRoute>
              <AIChatPage />
            </ProtectedRoute>
          } />
          <Route path="/upgrade" element={
            <ProtectedRoute>
              <UpgradePage />
            </ProtectedRoute>
          } />
          <Route path="/payment-success" element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          } />
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;